/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DefinitionMargins,
    DefinitionMarginsFromJSON,
    DefinitionMarginsFromJSONTyped,
    DefinitionMarginsToJSON,
    DefinitionStyleType,
    DefinitionStyleTypeFromJSON,
    DefinitionStyleTypeFromJSONTyped,
    DefinitionStyleTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface DefinitionOptions
 */
export interface DefinitionOptions {
    /**
     * 
     * @type {DefinitionMargins}
     * @memberof DefinitionOptions
     */
    definitionMargins?: DefinitionMargins;
    /**
     * 
     * @type {DefinitionStyleType}
     * @memberof DefinitionOptions
     */
    definitionStyleType?: DefinitionStyleType;
}

export function DefinitionOptionsFromJSON(json: any): DefinitionOptions {
    return DefinitionOptionsFromJSONTyped(json, false);
}

export function DefinitionOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefinitionOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'definitionMargins': !exists(json, 'definitionMargins') ? undefined : DefinitionMarginsFromJSON(json['definitionMargins']),
        'definitionStyleType': !exists(json, 'definitionStyleType') ? undefined : DefinitionStyleTypeFromJSON(json['definitionStyleType']),
    };
}

export function DefinitionOptionsToJSON(value?: DefinitionOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'definitionMargins': DefinitionMarginsToJSON(value.definitionMargins),
        'definitionStyleType': DefinitionStyleTypeToJSON(value.definitionStyleType),
    };
}


